import { Box, Typography, Button } from '@mui/material'
import { useNavigate } from 'react-router'
import { fontSizes, fontWeights } from '../../Components/Common/Typography/TypographyStyles'

const NotFoundPage = () => {
  const navigate = useNavigate()

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        textAlign: 'center',
        padding: 3,
      }}
    >
      <Typography
        variant='h1'
        color='error'
        sx={{ fontWeight: fontWeights[700], fontSize: fontSizes.size64 }}
      >
        404
      </Typography>
      <Typography variant='h4' sx={{ marginY: 2, fontSize: fontSizes.size16 }}>
        Page Not Found
      </Typography>
      <Typography variant='body1' sx={{ marginBottom: 3 }}>
        We couldn&apos;t find the page you&apos;re looking for.
      </Typography>
      <Button variant='contained' color='primary' onClick={() => navigate('/')} sx={{ marginTop: 3 }}>
        Go to Home
      </Button>
    </Box>
  )
}

export default NotFoundPage
